<template>
  <div class="main-menu-grouping-desktop tabs hidden-sm-and-down">
    <div class="v-tabs__bar main-menu-grouping-desktop__bar">
      <div class="v-tabs__wrapper">
        <div class="v-tabs__container">
          <template v-for="tab in tabsLayout" :key="tab.key">
            <div
              v-if="tab.type === mainMenuLayoutTypeEnum.delimiter"
              class="main-menu-grouping-desktop__line-decoration"
            />

            <div
              v-else-if="!tab.subItems && tab.showCondition"
              :class="{ active: tab.active }"
              class="main-menu__tab main-menu-grouping-desktop__tab"
              :aria-label="tab.title"
            >
              <router-link
                v-if="tab.link"
                class="v-tabs__item"
                :to="tab.link"
                @click.prevent="tab.click && tab.click($event)"
              >
                <ui-icon class="mr-4" size="12" :icon="tab.icon"></ui-icon>
                {{ tab.title }}
              </router-link>
            </div>

            <div
              v-else-if="tab.subItems && tab.showCondition"
              class="v-tabs__v-menu main-menu__tab main-menu-grouping-desktop__tab main-menu__tab--select"
              :class="{ active: tab.active }"
            >
              <ui-menu
                v-model="menuOpened[tab.key]"
                content-class="main-menu-grouping-desktop__dropdown-menu"
                location="bottom start"
                :offset="[0, 29]"
                :open-on-hover="true"
                :items="tab.subItems"
                :eager="true"
              >
                <template v-slot:activator>
                  <a class="v-tabs__item" :class="{ 'v-tabs__item--active': tab.active }">
                    <ui-icon class="mr-4" size="12" :icon="tab.icon"></ui-icon>
                    {{ tab.title }}
                    <ui-chevron
                      class="v-tabs__item-carret-icon"
                      color="inherit"
                      size="13"
                      :open="menuOpened[tab.key]"
                    />
                  </a>
                </template>

                <template v-slot:item="{ item }">
                  <router-link
                    v-if="tab.type === mainMenuLayoutTypeEnum.tabCustom && item?.link"
                    class="main-menu-grouping-desktop__dropdown-menu-link"
                    :to="item.link"
                    @click.prevent="item.click && item.click($event)"
                  >
                    <div class="main-menu__custom-name">{{ item.meta?.customValue }}</div>
                    <div class="main-menu__custom-value">{{ item.title }}</div>
                  </router-link>

                  <router-link
                    v-else-if="item?.link"
                    :class="[
                      'ui-menu-content-item__text',
                      'main-menu-grouping-desktop__dropdown-menu-link',
                    ]"
                    :to="item.link"
                    @click.prevent="item.click && item.click($event)"
                  >
                    {{ item.title }}
                  </router-link>
                </template>
              </ui-menu>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMainMenuGrouping } from '@/composables';

const { menuOpened, mainMenuLayoutTypeEnum, tabsLayout } = useMainMenuGrouping();
</script>

<style lang="scss">
.v-tabs__wrapper {
  overflow: hidden;
  display: flex;
}
.main-menu-grouping-desktop {
  width: 100%;
  display: flex;
  &__dropdown-menu {
    z-index: 100 !important;
  }

  &__dropdown-menu-link {
    display: flex;
    flex-wrap: nowrap;
    text-decoration: none;
  }

  &__bar {
    background-color: var(--color-white);
    border-color: var(--color-white);
    width: 100%;
    box-shadow: 0 1px 2px 0 var(--color-black10);
  }

  .v-tabs__container {
    display: flex;
    flex-flow: wrap;
    padding: 0 16px;
    height: unset;
    width: 100%;
  }

  & &__tab a {
    color: var(--color-graphite);
    line-height: 18.5px;
  }

  &__tab {
    margin: 6px 1px;
    display: flex;

    .v-tabs__item {
      padding: 4px 8px;
      display: flex;
      align-items: center;
      flex: 1 1 auto;
      height: 100%;
      justify-content: center;
      max-width: inherit;
      text-decoration: none;
      text-transform: capitalize;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }

    &.main-menu__tab--select .ui-chevron__icon {
      font-size: 13px;
    }

    &.active a,
    &:hover a {
      background-color: var(--color-green);
      color: var(--color-white);
      border-radius: 4px;

      .ui-icon {
        color: var(--color-white) !important;
      }
    }
  }

  &__line-decoration {
    align-items: center;
    display: flex;
    // width: 100%;
    padding-left: 10px;
    padding-right: 10px;

    &::before {
      content: '';
      width: 2px;
      height: 24px;
      border-radius: 1px;
      background-color: var(--color-gray10);
      display: block;
    }

    @media (max-width: 1300px) {
      & {
        flex-basis: 100%;

        &::before {
          display: none;
        }
      }
    }
  }
}
</style>
